import React from "react";
import { AddressDeleteBody } from "tsi-common-react/src/apps/customer-account/AddressDeleteBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AddressDeleteDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AddressDeleteBody {...props} buttonModifierClass="button--ming" />
    </PageSkeleton>
);
